<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-07 19:04:16
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-07 19:28:47
 * @FilePath: /chaoyongtuan/src/views/shopManage/shopLibrary/addMaterial/components/local/tacbleCells/materialCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<div class="flex-row">
			<el-image style="width: 32px; height: 40px" fit="cover" class="radius-4" :src="row.coverUrl + '?x-oss-process=image/resize,l_100'">
				<template v-slot:placeholder>
					<img style="width: 32px; height: 40px" src="@/assets/public/empty_ranking.png" alt="" />
				</template>
				<template v-slot:error>
					<img style="width: 32px; height: 40px" src="@/assets/public/empty_ranking.png" alt="" />
				</template>
			</el-image>
			<div class="ml-8">
				<div class="flex-row-align-center">
					<rdShopInfo :shopInfo="{ name: row.title }" :showShopIcon="true" :textWidth="94"></rdShopInfo>
					<span class="tipsTop fz-12" v-if="row.isTop == 1">置顶</span>
				</div>
				<rdText :useByTable="false" label="ID" :showCopy="false">{{ row.id }}</rdText>
			</div>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
	data() {
		return {};
	},

	computed: {},
	props: {},

	mounted() {},

	methods: {},
};
</script>
<style lang="less" scoped>
.tipsTop {
	background: @color-primary;
	border-radius: 3px;
	color: #fff;
	padding: 0 3px;
	margin-left: 5px;
	line-height: 20px;
}
</style>
